import * as React from "react";
const AspirationIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    {...props}
  >
    <path
      fill="#4D4D4D"
      d="M13.333 6.667H12V0h1.333L16 1.667l-2.667 1.666v3.334ZM8 11v5H0v-5c0-.92.748-1.667 1.667-1.667H2V9c0-.551.449-1 1-1h2c.551 0 1 .449 1 1v.333h.333C7.252 9.333 8 10.081 8 11Zm-1.333 2.333h-2V14H3.333v-.667h-2v1.334h5.334v-1.334Zm0-2.333a.334.334 0 0 0-.334-.333H1.667a.334.334 0 0 0-.334.333v1h5.334v-1Zm6.666-1.667h-2.666A1.335 1.335 0 0 1 9.333 8c0-.735.598-1.333 1.334-1.333V5.333A2.67 2.67 0 0 0 8 8a2.67 2.67 0 0 0 2.667 2.667h2.666c.736 0 1.334.598 1.334 1.333s-.598 1.333-1.334 1.333h-4v1.334h4A2.67 2.67 0 0 0 16 12a2.67 2.67 0 0 0-2.667-2.667Z"
    />
  </svg>
);
export default AspirationIcon;
